import { Button, Col, Descriptions, Form, Input, Row } from 'antd'
import LenderModal from '../../../components/Finance/Lender/LenderModal'
import Status from '../../../elements/Status'
import React, { Fragment } from 'react'

function LenderDetails(props) {
  const { lender, onEdit } = props

  return (
    <Fragment>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Descriptions bordered column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Status">
            <Status value={lender.status} />
          </Descriptions.Item>
          <Descriptions.Item label="Location">{lender.location}</Descriptions.Item>
          <Descriptions.Item label="Tax Registration">
            {lender.taxRegistration || 'N/A'}
          </Descriptions.Item>
        </Descriptions>
      </Row>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Button onClick={onEdit} type="dashed" icon="user-add">
          Update Lender
        </Button>
        <LenderModal {...props} />
      </Row>
    </Fragment>
  )
}

export default LenderDetails
